import { css, SerializedStyles } from '@emotion/core'
import React, { ReactNode } from 'react'

interface Props {
  children: ReactNode
  cssProps?: SerializedStyles
}

const Body: React.FunctionComponent<Props> = ({ children, cssProps }) => {
  return (
    <div className="body" css={[bodyStyle, cssProps]}>
      {children}
    </div>
  )
}

export default Body

const bodyStyle = css`
  width: 100%;
`
